import { render, staticRenderFns } from "./CalcL.vue?vue&type=template&id=bfc6cbae&scoped=true"
import script from "./CalcL.vue?vue&type=script&lang=ts"
export * from "./CalcL.vue?vue&type=script&lang=ts"
import style0 from "./CalcL.vue?vue&type=style&index=0&id=bfc6cbae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc6cbae",
  null
  
)

export default component.exports